module.exports = __webpack_public_path__ + "img/guide02.100ab1cc.png";